export const formatInputValue = (value) => {
	const res = value.replace(/\D/g, '').replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
	return res;
};
